<template>
  <div>
  
    
  <b-row >
       
    <!----- SideBar All Design List ---->
     <sidebarSettingsComponent></sidebarSettingsComponent>
    <!----- SideBar All Design List End ----> 

     <div class="design-container-details__main">
      <div class="col-md-12 ">


            <!-- code for table -->
              <b-row>
                
                <!-- <b-col md="12"> -->
                  <b-card-body>
                  <div class="row mt-4"> 
                    <div class="col-md-6 pull-left"><h4>My Vendors Details</h4>
                    </div>
                     
                  </div>  
                    
                    <div class="float-right"> 
                      <p > <b>Total Records :<span style="color:red;">{{ this.user_totalRows }}</span></b> </p>
                     </div>
                     <!-- {{brand_item}} -->
                     <b-col md="12">
                    <b-table class="mt-4" show-empty stacked="md" :busy="isBusy"  :items="vendor_list"  :fields="fields"   :bordered="bordered"       :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection" >
                  
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                    <template slot="actions" slot-scope="row" v-if="user_type=='Brand_Manager'">
                      <!-- <div class="form-check">
                        <div v-if="row.item.is_dh_available==1">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="yes" value="1" v-model="row.item.is_dh_available" @change="changedesignhead(row.item,1); checked">Yes&nbsp;&nbsp;&nbsp;&nbsp;
                        <input class="form-check-input" type="radio" name="flexRadioDefault" value="1" id="no" v-model="row.item.is_dh_available" @change="changedesignhead(row.item,0);">No
                      </div>
                      <div v-if="row.item.is_dh_available==0">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="yes" value="1" v-model="row.item.is_dh_available" @change="changedesignhead(row.item,1);">Yes&nbsp;&nbsp;&nbsp;&nbsp;
                        <input class="form-check-input" type="radio" name="flexRadioDefault" value="0" id="no" v-model="row.item.is_dh_available" @change="changedesignhead(row.item,0); checked">No
                      </div>
                        
                        
                      </div> -->
                      <div class="form-check">
                        <!-- <div v-if="row.item.is_dh_available==1"> -->
                        <!-- <input class="form-check-input" type="checkbox" value="0" id="defaultCheck1" v-bind:value="row.item.is_dh_available" @change="changedesignhead(row.item,row.item.is_dh_available);"> -->
                        <input class="form-check-input" type="checkbox" value=""
                        id="flexCheckChecked" v-model="row.item.is_dh_available" checked @change="changedesignhead(row.item,row.item.is_dh_available);"/>
                        <!-- </div>
                        <div v-if="row.item.is_dh_available==0">
                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" v-model="row.item.is_dh_available" @change="changedesignhead(row.item,0);">
                        </div> -->

                      </div>
                    </template>            
                  </b-table>
                 
                </b-col>
                  </b-card-body>
               <!-- </b-col> -->
            </b-row>          
             <!-- code for table ends -->

 
      </div>
    </div>     
      
  </b-row>    





    
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'



import sidebarSettingsComponent from './_sidebarSettingsComponent.vue'

const axios = require('axios')
export default {
  name: 'Tabs',
 components: {
    sidebarSettingsComponent
  },  
  data () {
    return {
      isBusy: false,  
      sampelAddModal: false,    
      customer: {},
      addAgentMaster : false,
      editAgentMaster:false,
      bordered: true,
      showSideMenu:true,
      items:[],
      result:[],
      value:[],
      sortDesc: true,
      sortDirection: 'desc',
      user_type: '',
      sortBy: null,
      fields: [
          // { key: 'vendor_id', label: 'Vendors ID', sortable: true, sortDirection: 'desc', },
          { key: 'vendor_name', label: 'Vendor Name', sortable: true, tdClass: 'userclass'},
          { key: 'contact_person', label: 'Contact Person', sortable: true, tdClass: 'contactclass'},
           { key: 'vendor_code', label: 'Vendor Code', sortable: true, tdClass: 'userclass'},
           { key: 'email_id', label: 'Email ID', sortable: true, tdClass: 'userclass'},
           { key: 'vendor_state', label: 'Vendor State', sortable: true, tdClass: 'userclass'},
          { key: 'vendor_city', label: 'Vendor City',tdClass: 'userclass' },
          { key: 'vendor_address', label: 'Vendor Address',tdClass: 'contactclass' },
          { key: 'actions', label: 'Action',tdClass: 'userclass' }
         
      
       ],
      showexistingusermodel: false,
      user_list:[],
      selected_user: 0,
      selected:'',
      selected_brand_id: 0,
      selected_user: [],
      selected_user_length: 0,
      isCheckAll: false,
      user_list_msg: '',
      items_message: '',
      user_totalRows: 0,
      vendor_list:[],
      dh_status:false,
      is_dh_available: 0,

      // checked: 1,
   }

  },
  created: function() { 
  this.getvendorlist();
  // this.getCreatedUserList(); 
  
  var userdata = localStorage.getItem("userData");
  var userInfo = JSON.parse(userdata);
   this.user_type = userInfo[0].user_type;
   if(this.user_type!='Admin'){
    this.getexistinguserlist();
   }
  },
  
  methods: 
  {   
    
      changedesignhead: function(value,dh_status){
        console.log("value",value);
        console.log("status",dh_status);
        var temp_dh_status=1
        if(dh_status==true){
          temp_dh_status= 1;
        }
        else{
          temp_dh_status= 0;
        }
    document.getElementById("overlay").style.display = "block";

      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
        const Obj={
           brand_id: value.brand_id,
           user_id: userInfo[0].user_id,
          is_dh_available: temp_dh_status
        }
        axios.post(`${CONSTANTS.API_URL}/updatedesignhead`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === 'Successful') {
            // alert("Design Head Updated Successfully");
             this.$fire({
                 text:"Design Head Updated Successfully.",
                 type: "success",
                 timer: 30000
                        })
            this.getCreatedUserList();
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      //}
  },

      //Code For Select Brand
      getvendorlist: function(){
       document.getElementById("overlay").style.display = "block";
        var userData = localStorage.getItem('userData');
       var userInfo = JSON.parse(userData);

         this.isBusy = true;  
         const Obj ={
           user_id: userInfo[0].user_id,
           brand_id: userInfo[0].brand_assign
         }  
        axios.post(`${CONSTANTS.API_URL}/getassignedvendortoQC_Executive`,Obj)
        .then(response => {

          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === 'Successful') {
            this.vendor_list  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            // this.isBusy = !this.isBusy;
            
          }else {
           this.vendor_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      },
      //Code Ends For Select Brand
  

    //Code For Existing User List
    getexistinguserlist: function() 
    {
      // document.getElementById("overlay").style.display = "block";

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      
      this.selected_brand_id= userInfo[0].brand_assign
     const Obj = {
              brand_manager : userInfo[0].user_id,
              brand_id: userInfo[0].brand_assign
            }
      this.isBusy = true;       
        axios.post(`${CONSTANTS.API_URL}/getExistingUsers`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data
          this.user_list_msg=this.result.returnmsg;
          if (this.result.returnmsg === 'Successful') {

            this.user_list  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = false;
            
            
          }else {
           this.user_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })

    },
    //Code For Existing User List Ends


    getCreatedUserList: function() 
    {
      document.getElementById("overlay").style.display = "block";

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
     
      this.login_user_id = userInfo[0].user_id;

     const Obj = {
              created_by : this.login_user_id,
              user_type: userInfo[0].user_type,
              brand_id: userInfo[0].brand_assign
            }

        // this.isBusy = true;      
        axios.post(`${CONSTANTS.API_URL}/getCreatedUserList`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
         
          
          this.isBusy != this.isBusy; 
          if (this.result.returnmsg === 'Successful') {
             
            this.items  = this.result.returnvalue;
            this.user_totalRows = this.result.returnvalue.length;
            // this.isBusy = false;
            
          }else {
           this.items =[];
           this.user_totalRows=0;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })

    },

  }
}
</script>
<style>
.account-settings__content>* {
    flex-grow: 1;
}

.profile-settings {
    flex-grow: 1;
    padding: 20px 24px;
}

.profile-settings>h1 {
    font-weight: 600;
    padding: 0;
    margin: 0;
}
.profile-settings .content {
    display: flex;
}
.profile-settings .content .profile-fields-container {
    max-width: 356px;
    margin-right: 56px;
}
.profile-settings .tabular-fields {
    font-size: 14px;
    line-height: 20px;
    flex-direction: column;
}
.profile-settings .tabular-fields .field-row {
    margin-top: 20px;
    min-height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.profile-settings .tabular-fields .field-row>.field-label {
    color: var(--fill-grey-medium);
    min-width: 100px;
    margin: 12px 0;
}
.profile-settings .tabular-fields .field-row>.field-value {
    margin-left: 32px;
    flex-grow: 1;
}

.design-container-details__main{
 
  background-color:white;
  border-left:1px solid #d4d4d4;

}

.profile-settings .content .img.img-invalid {
    background-color: #6f4ce6;
}
.profile-settings .content .img {
    max-width: 100%;
    position: relative;
    height: 175px;
    width: 175px;
    border-radius: 4px;
    overflow: hidden;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    border: 1px solid var(--fill-grey-light2);
    padding: 5px;
}
.userclass{
  word-wrap: break-word; 
  column-width: fixed;
  max-width: 80px !important;
}
.contactclass{
  word-wrap: break-word; 
  column-width: fixed;
  max-width: 50px !important;
}

</style>


